import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dashboard_card_icon_menu_window",
  "use": "dashboard_card_icon_menu_window-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"dashboard_card_icon_menu_window\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2V3H4Zm0-2a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H4Zm4 2v14h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H8Z\" fill=\"#2D2C34\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol